import React, { useState, useEffect, useRef } from "react";
import "./ScreenSize.css";
import { Button } from "@mui/material";
import { Fullscreen, FullscreenExit } from "@mui/icons-material";
const ScreenSize = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const hideTimeout = useRef(null); 
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
        .then(() => setIsFullscreen(true))
        .catch(err => console.error("Fullscreen error:", err));
    } else {
      document.exitFullscreen()
        .then(() => setIsFullscreen(false))
        .catch(err => console.error("Exit fullscreen error:", err));
    }
  };
  const handleMouseMove = () => {
    setIsVisible(true);
    if (hideTimeout.current) clearTimeout(hideTimeout.current);
    hideTimeout.current = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };
  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      if (hideTimeout.current) clearTimeout(hideTimeout.current);
    };
  }, []);

  return (
    isVisible && (
      <span className="screen-size-button" onClick={toggleFullscreen}>
        {isFullscreen ? <FullscreenExit style={{ fontSize: "2vw" }} /> : <Fullscreen style={{ fontSize: "2vw" }} />}
      </span>
    )
  );
};
export default ScreenSize;
